import { CardGroupActions } from './../actions/card-group.actions';
import { tassign } from 'tassign';
import { RidangoReduxAction, CardGroup } from '@ridango/core';



export interface CardGroupState {
    all: CardGroup[];
    selected: CardGroup;
}
export const CARD_GROUP_INITIAL_STATE: CardGroupState = {
    all: [],
    selected: null
};

export function cardGroupReducer ( lastState: CardGroupState = CARD_GROUP_INITIAL_STATE, action: RidangoReduxAction ): CardGroupState {
    switch ( action.type ) {
        case CardGroupActions.SET_ALL_CARD_GROUPS:
            return tassign( lastState, { all: action.payload } );
        case CardGroupActions.SET_SELECTED_CARD_GROUP:
            return tassign( lastState, { selected: action.payload } );
        case CardGroupActions.CLEAR_CARD_GROUPS:
            return tassign( lastState, CARD_GROUP_INITIAL_STATE );
    }
    // We don't care about any other actions right now.
    return lastState;
}
